import { useDisclosure } from '@mantine/hooks'
import { Close, Menu } from '@mui/icons-material'
import {
  AppBar,
  Container,
  IconButton,
  Stack,
  Toolbar,
  useScrollTrigger,
  useTheme,
} from '@mui/material'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import AuthButton from '~/features/auth/components/authButton'
import EElement from '~/features/ui/models'
import Logo from '~/layouts/app/header/logo'
import Nav from '~/layouts/app/header/nav'
import SmallScreenNav from '~/layouts/app/header/nav/small'
import { EMarketingClientPath } from '~/models/api'

function Header() {
  const scrollTrigger = useScrollTrigger({
    threshold: 0,
    disableHysteresis: true,
  })
  const [menuOpen, { open, close }] = useDisclosure(false)
  const theme = useTheme()
  const trigger = scrollTrigger && !menuOpen
  const location = useLocation()

  const backgroundColor = useMemo(() => {
    if (trigger) {
      return theme.palette.common.white
    }
    if (location.pathname === EMarketingClientPath.home) {
      return 'transparent'
    }
    return theme.palette.mainFont
  }, [trigger, location, theme])

  const style = {
    backgroundColor,
    transition: 'background-color 0.5s ease-in-out',
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: trigger ? undefined : 'none',
  }

  const showLg = { xxxs: 'none', lg: 'inherit' }

  return (
    <>
      <AppBar id={EElement.appHeader} sx={style}>
        <Toolbar disableGutters>
          <Container>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Logo colorTrigger={trigger} />

              <Stack direction="row" alignItems="center">
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={menuOpen ? close : open}
                  sx={{
                    mr: { xxxs: 0, xs: 2 },
                    display: { lg: 'none' },
                    color: trigger
                      ? theme.palette.mainFont
                      : theme.palette.grey[300],
                  }}
                >
                  {menuOpen ? <Close /> : <Menu />}
                </IconButton>
                <Nav colorTrigger={trigger} sx={{ display: showLg }} />
                <AuthButton
                  variant={trigger ? 'secondary' : 'secondaryDark'}
                  sx={{
                    px: { xxxs: 1, xs: 2, sm: 4 },
                    fontSize: { xxxs: '0.75rem', xs: '1rem' },
                  }}
                />
              </Stack>
            </Stack>
          </Container>
        </Toolbar>
      </AppBar>
      <SmallScreenNav isOpened={menuOpen} close={close} />
    </>
  )
}

export default Header
